var headerItem = {
  data () {
    return {
      scrollTop: 0,
      isToolbar: false
    }
  },
  computed: {
    bannerHeight() {
      return this.bannerCardHeight || this.$config.page.bannerHeight;
      },
      isToolbars() {
        return this.scrollTop > this.bannerHeight - 100;
      },
      dark () {
        return this.$store.state.config.dark
      },
      cardStyle(){
        if (this.collapseToolbar) return {
          'max-width': this.$config.page.width + 'px'
        }
        return {
          'margin-top': (this.bannerHeight - 15)  + 'px', //this.$vuetify.breakpoint.mobile ?  : (this.bannerHeight + 20)  + 'px',
          'max-width': this.$config.page.width + 'px'
        }
      },
    },
    created() {
      window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    },
   methods: {
    handleScroll(event) {
      this.scrollTop = window.scrollY;
      this.isToolbar = (this.scrollTop > this.bannerHeight - 100)
      
    },
   }
    
  }


  export default headerItem